import ja from '../libs/i18n/ja.json';

export enum DIALOG_TYPE {
    NONE = 'none',
    CREATE = '0',
    UPDATE = '1',
    DELETE = '2',
    SEARCH = '3',
    IMAGE = '4',
    CHORE = '5',
    QRCODE = '6',
    REVERT = '7',
    REGISTER = '8',
    COMPLETE = '9',
    COMPLETE_INPUT = '10',
    CHART = '11',
    EXPORT = '12',
}

export enum ALERT_TYPE {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning',
}

export enum USER_TYPE_ENUM {
    employee = '0',
    broker = '1',
    otp = '2',
}

export enum SCREEN_TYPE {
    list = 'list',
    register = 'register',
    detail = 'detail',
    detailLv1 = 'detailLv1',
}

export type CellBuilder = (index: number) => DataGridCell[];
export type SortListener = (columnIndex: number, ascending: boolean) => void;
export type TapListener = (rowIndex: number) => void;
export type SelectedCallback = (selected: number[]) => void;
export type ColumnDragCallback = (newColumns: DataGridColumn[]) => void;
export type RowDragCallback = (newOrder: number[]) => void;
export type TapLinkListener = (rowIndex: number) => void;
export type TapIconActionListener = (rowIndex: number) => void;
export type PageChangeCallback = (currPage: number) => void;

export enum AuthorizationList {
    UNDEFINED = 0,
    INSTALLATION = 1, // 設置
    COLLECTION = 2, // 回収
    RESTOCK = 3, // 入荷
    MOVING = 4, // 移動
    PROCESSING = 5, // 処理投入
    SHIPPING = 7, // 出荷
    UNIT_INTEGRATION = 18, // ユニット統合
    INVENTORY = 8, // 棚卸
    MANAGEMENT = 9, // マスタ管理
    LANGUAGE = 10, // 文言管理
    UNIT = 11, // ユニット
    TRACE = 12, // トレース
    INVENTORY_MANAGEMENT = 13, // 在庫管理
    WORK_HISTORY = 14, // 作業履歴
    WORK_HISTORY_EDIT = 15, // 履歴修正
    DASHBOARD = 16, // ダッシュボード
    CONTAINER_COLLECTION = 17, // コンテナ回収
}

export enum FormProcessingType {
    ProcessingInput = 'processing_input',
    ProcessingOutput = 'processing_output',
}

export enum FormTrackingType {
    TrackingBack = 'tracking_back',
    TrackingForward = 'tracking_forward',
}

export type TKeysType = {
    [K in keyof typeof ja]: K;
};

export const TKeys = Object.keys(ja).reduce<Record<string, string>>((acc, key) => {
    acc[key] = key;
    return acc;
}, {}) as TKeysType;

export enum STATUS_TYPE {
    VALID = 1,
    INVALID = 0,
}

export enum USER_ROLE {
    GENERAL = 0,
    ADMIN = 1,
    SYS_ADMIN = 2,
    MASTER_ADMIN = 99,
}

export enum GENERATE_PRESIGNED_URL_TYPE {
    UPLOAD = 'upload',
    DOWNLOAD = 'download',
}

export enum DIALOG_STATUS {
    REGISTER = 1,
    COMPLETE = 2,
}

export enum ACTION_TYPE {
    EDIT = 0,
    DELETE = 1,
}

export enum ACTION_TYPE_ITEM {
    SAVE = 0,
    COMPLETE = 1,
    CANCEL = 2,
}

export enum QR_TYPE {
    PDF = 'pdf',
    PRINT = 'print',
}

export enum TRACKING_TYPE {
    TRACKING_BACK = 'TRACKING_BACK',
    TRACKING_FORWARD = 'TRACKING_FORWARD',
}

export enum XMP_RESPONSE {
    SUCCESS = 'OK',
    FAILED = 'NG',
}

export enum UNIT_ID_DEGIT {
    MIN = 7,
    MAX = 16,
}

export enum DAY_OF_ADVANCE_NOTICE {
    MIN = 0,
    MAX = 180,
}

export enum OBJECT_TYPE_HISTORY {
    USER_MASTER = 0,
    CONTAINER_MASTER = 1,
    TASK_EDIT = 2,
    CONTENT_MASTER = 3,
}

export enum CSV_UPLOAD_STEP {
    Select = 'select',
    Uploading = 'uploading',
    Importing = 'importing',
    Error = 'error',
    NoData = 'noData',
    Success = 'success',
}

export enum ALERT_ACTION {
    SHOW_REMAIN_LIST = 'SHOW_REMAIN_LIST',
}
